// extracted by mini-css-extract-plugin
module.exports = {"infoModalContent":"Header_infoModalContent__KJ5oq"};